import styled from "styled-components";

export const EmptyAnimatedContainer = styled.div`
& .notfound-text {
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
}
`
